import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import reportWebVitals from './reportWebVitals'
import {
  createHashRouter,
  RouterProvider,
} from 'react-router-dom'
import 'bootstrap/dist/css/bootstrap.min.css'

import Login from './views/Login'
// import Dashboard from './views/Dashboard/Dashboard'
import TapMenu from './views/tapMenu'
import PersonQuery from './views/PersonQuery'
import GroupQuery from './views/GroupQuery'
import TheoreticalEvaluation from './views/theoreticalEvaluation'

const router = createHashRouter([
  {
    path: '/',
    element: <Login />
  },
  {
    path:'/menu',
    element: <TapMenu />
  },
  // {
  //   path: '/dashboard',
  //   element: <Dashboard />
  // },
  {
    path: '/consulta-certificados-persona',
    element: <PersonQuery />
  },
  {
    path: '/consulta-certificados-equipo',
    element: <GroupQuery />
  },
  {
    path: '/theoretical-evaluation',
    element: <TheoreticalEvaluation />
  },
])


const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
)

reportWebVitals()
